import React, { useRef, useState } from 'react';
import Feedback1 from './../../../src/images/feedback.jpg'
import Feedback2 from './../../../src/images/feedback2.jpg'
import Feedback3 from './../../../src/images/feedback3.jpg'
import Feedback4 from './../../../src/images/feedback4.jpg'
import Feedback5 from './../../../src/images/feedback5.jpg'
import Quote from './../../../src/images/quote.png'

import './Testimonials.css';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const TestimonialsSlider = () => {

    const PortfolioSliderImage = [
        {
            id: 1,
            img: Feedback1,
            name: 'Taiful Islam',
            designation: 'Manager (HRD)',
            massage: 'Wow, your website design is stunning! The color scheme and layout are both visually appealing and easy to navigate. Great job!',
        },
        {
            id: 2,
            img: Feedback2,
            name: 'Abdur Rahim',
            designation: 'Brand Manager',
            massage: 'Your website design is clean and minimalistic, which makes it easy for users to focus on the content. The font choice and spacing also contribute to a great user experience.',
        },
        {
            id: 3,
            img: Feedback3,
            name: 'Jahid Hasan',
            designation: 'Sr. WordPress Developer',
            massage: "I'm really impressed by the user experience of your website. It's intuitive and easy to navigate, and everything loads quickly. Your attention to detail really shines through in every aspect of the design.",
        },
        {
            id: 4,
            img: Feedback4,
            name: 'Al Kaium Sumon',
            designation: 'Quality Controller',
            massage: "I appreciate the attention to detail in your website design. The subtle animations and responsive layout really make it stand out from other sites. Well done!",
        },
        {
            id: 5,
            img: Feedback5,
            name: 'Imran Hossain Roney',
            designation: 'CFO',
            massage: "The design of your website is nice, but it could benefit from more contrast and larger font sizes for improved readability. Additionally, the placement of some elements could be reconsidered to create a more intuitive user experience.",
        }
    ]


    const settings = {
        infinite: true,
        speed: 500,
        autoplaySpeed: 2000,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div className='px-5  testimonials_slider'>
            <Slider {...settings} >
                {
                    PortfolioSliderImage.map(feedback =>
                        <div className='px-3 ' >
                            <div className='h-100 text-light p-5 border rounded' style={{ backgroundColor: '#2C304A' }}>
                                <div className='d-flex justify-content-between  '>
                                    <div className='d-flex flex-row'>
                                        <img src={feedback.img} alt="your-image-alt-text" class="rounded-circle" width="60" height="60" />
                                        <div className='ps-3'>
                                            <h5>{feedback.name}</h5>
                                            <p>{feedback.designation}</p>
                                        </div>
                                    </div>
                                    <div>
                                        <img src={Quote} alt="your-image-alt-text" class="rounded-circle" width="60" height="60" />
                                    </div>
                                </div>
                                <div>
                                    <p>
                                        {feedback.massage}
                                    </p>
                                </div>
                            </div>
                        </div>)
                }
            </Slider>
        </div>
    );
};

export default TestimonialsSlider;